import React from "react";
import LearnMore from "../../../../../components/learnMore/learnMore";

const MembershipBreakdownLearnMore = ({ sourceType, organizationName }) => {
  return (
    <LearnMore
      title="Membership Breakdown"
      learnMoreId="membershipBreakdownLearnMore"
      content={getContent(sourceType, organizationName)}
      html
    />
  );
};

const getContent = (sourceType = "", organizationName) => {
  let content = "";
  let capitalizedSourceType = sourceType.charAt(0) + sourceType.substring(1);
  if (sourceType === "clubready") {
    content = getClubreadyText(organizationName);
  } else {
    content += `
      <div>
        The <b>Membership Breakdown</b> table lets you view today’s total active members per pricing
        option. You can also track revenue and customer behavior for each pricing option. This
        information is based on your current active members.
        <br />
        <br />
        <h3>Cost:</h3>
        Syncs with the ${capitalizedSourceType} services and pricing menu to display the default cost
        of your pricing option.
        <br />
        <br />
      </div>`;

    if (sourceType === "mindbody") {
      content += mindbodyText;
    } else {
      content += otherText;
    }
  }

  return content;
};

const getClubreadyText = (organizationName) => {
  return `
      The <b>Membership Breakdown</b> table and pie chart explores
      memberships in order to discover insights into membership revenue and membership composition.
      A toggle on the chart will switch the view of the table and pie chart from category down to
      pricing option.
      <br />
      <br />
      <h4>
        <b>Active:</b>
      </h4>
      Excludes frozen members but includes paying and non-paying members.
      <br />
      <br />
      <h4>
        <b>Paying:</b>
      </h4>
      All non-frozen members that are paying. Excludes members who are not paying due to delinquency
      or due to receiving a free membership. <b>Please note that ONLY current non-frozen agreements will
       be calculated to be in Paying. When looking historically a current frozen member who was not 
       frozen during the time frame selected will show as Non-Paying even if they had a success payment
        during the agreement window.</b>
      <br />
      <br />
      <h4>
        <b>Non-Paying:</b>
      </h4>
      Members that do not have a payment during the last payment duration time period according to
      their agreement. For example: If a member is required to make a payment every 30 days
      according to their agreement and there is no payment in the last 30 days, the member will be
      counted as a non-paying member. Non-paying members can include members whose last payment was
      declined.
      <br />
      <br />
      <h4>
        <b>Frozen:</b>
      </h4>
      Count of members with frozen status.
      <br />
      <br />
      ${
        organizationName !== "Mayweather"
          ? `<h4>
            <b>Revenue:</b>
          </h4>
          The revenue column shows how much you earn per member (excluding frozen members) based on
          their last payment on the pricing option. More specifically, the duration of the
          membership pricing option is used as a reference to how long it should look back for the
          last purchase. For example, if the duration of a membership is 30 days based on the last
          pricing option purchased, the column looks 30 days back to find this purchase and adds it
          to the revenue column of the table.
          <br />
          <br />`
          : ""
      }
      <h4>
        <b>Avg. Revenue Per Paying Member:</b>
      </h4>
      Total revenue of the paying members (total paying revenue divided by the number of paying
      members).
      <br />
      <br />
      <h3>
        <b>Report Settings</b>
      </h3>
      <br />
      <h4>
        <b>Group Memberships by Revenue Category Button:</b>
      </h4>
      This changes aggregation of memberships from pricing option to revenue category.
      <br />
      <br />
      <h4>
        <b>Include/Exclude $0 Sales Button:</b>
      </h4>
      This button can exclude or include $0 sales from the average membership calculation. When
      toggled on, total revenue will only be divided by paying members. When toggled off, the paying
      members column and avg. per member rawdataview don’t include members with $0 sales.
      <br />
      <br />
      <h5>
        <b>
          Note: If the organization uses paying logic for counting members, then the breakdown is
          available for all time. In other case, it shows data only for last 36 month.
        </b>
      </h5>
    `;
};

const mindbodyText = `
    <h3>Active:</h3>
    Excludes frozen members but includes paying and non-paying members.
    <br />
    <br />
    <h3>Paying:</h3>
    All non-frozen members that are paying. Excludes members who are not paying due to delinquency
    or due to receiving a free membership. <b>Please note that ONLY current non-frozen agreements will
     be calculated to be in Paying. When looking historically a current frozen member who was not
      frozen during the time frame selected will show as Non-Paying even if they had a success payment
       during the agreement window.</b>
    <br />
    <br />
    <h3>Non-Paying:</h3>
    Members that do not have a payment during the last payment duration time period according to
    their agreement. For example: If a member is required to make a payment every 30 days according
    to their agreement and there is no payment in the last 30 days, the member will be counted as a
    non-paying member. Non-paying members can include members whose last payment was declined.
    <br />
    <br />
    <h3>Suspended:</h3>
    Count of members with frozen status.
    <br />
    <br />
    <h3>Revenue:</h3>
    Total of all members’ latest purchase amount for that pricing option. Note: This may not equal
    Members x Cost if discounts were issued on the pricing option.
    <br />
    <br />
    <h3>Avg. Revenue Per Paying Member:</h3>
    Total revenue of the paying members (total paying revenue divided by the number of paying
    members).
    <br />
    <br />
    <h3>Visits Last 30 Days:</h3>
    Total of all active member visits for each pricing option in the last 30 days.
    <br />
    <br />
    <h3>Average Visits Last 30 Days:</h3>
    Average visits from all active members on that pricing option in the last 30 days. This helps
    measure the success of each membership based on how often members visit.
    <br />
    <br />
    <h3>Earned Revenue Per Visit:</h3>
    Totals revenue by membership and assigns a value based on the number of visits. Note: This
    metric varies during the current month to report the previous month’s ending value. This helps
    clarify if the value per visit is generating your desired revenue, while also comparing the per
    visit value of each membership.
    <br />
    <br />
    <h3>Report Settings</h3>
    <br />
    <h3>Group Memberships by Revenue Category Button:</h3>
    This changes aggregation of memberships from pricing option to revenue category.
    <br />
    <br />
    <h3>Include/Exclude $0 Sales Button:</h3>
    This button can exclude or include $0 sales from the average membership calculation. When
    toggled on, total revenue will only be divided by paying members. When toggled off, the paying
    members column and avg. per member rawdataview don’t include members with $0 sales.
    <br />
    <br />
    <h5>
      <b>Note: The breakdown shows data only for last 6 months.</b>
    </h5>
  `;

const otherText = `
    <h3>Active Members:</h3>
    Displays the current number of active members for each pricing option.
    <br />
    <br />
    <h3>Revenue:</h3>
    Total of all members’ latest purchase amount for that pricing option. Note: This may not equal
    Members x Cost if discounts were issued on the pricing option.
    <br />
    <br />
    <h3>Visits Last 30 Days:</h3>
    Total of all active member visits for each pricing option in the last 30 days.
    <br />
    <br />
    <h3>Average Visits Last 30 Days:</h3>
    Average visits from all active members on that pricing option in the last 30 days. This helps
    measure the success of each membership based on how often members visit.
    <br />
    <br />
    <h3>Earned Revenue Per Visit:</h3>
    Totals revenue by membership and assigns a value based on the number of visits. Note: This
    metric varies during the current month to report the previous month’s ending value. This helps
    clarify if the value per visit is generating your desired revenue, while also comparing the per
    visit value of each membership.
    <br />
    <br />
    <h5>
      <b>Note: The breakdown shows data only for last 6 months.</b>
    </h5>
`;

export default MembershipBreakdownLearnMore;
